export const orderTypes = {
  GET_ALL_ORDERS_START: "GET_ALL_ORDERS_START",
  GET_ALL_ORDERS_SUCCESS: "GET_ALL_ORDERS_SUCCESS",
  GET_ALL_ORDERS_FAILED: "GET_ALL_ORDERS_FAILED",
  GET_ALL_ORDERS_END: "GET_ALL_ORDERS_END",

  ADD_NEW_ORDER_BY_ADMIN_START: "ADD_NEW_ORDER_BY_ADMIN_START",
  ADD_NEW_ORDER_BY_ADMIN_SUCCESS: "ADD_NEW_ORDER_BY_ADMIN_SUCCESS",
  ADD_NEW_ORDER_BY_ADMIN_FAILED: "ADD_NEW_ORDER_BY_ADMIN_FAILED",
  ADD_NEW_ORDER_BY_ADMIN_END: "ADD_NEW_ORDER_BY_ADMIN_END",

  UPDATE_ORDER_BY_ADMIN_START: "UPDATE_ORDER_BY_ADMIN_START",
  UPDATE_ORDER_BY_ADMIN_SUCCESS: "UPDATE_ORDER_BY_ADMIN_SUCCESS",
  UPDATE_ORDER_BY_ADMIN_FAILED: "UPDATE_ORDER_BY_ADMIN_FAILED",
  UPDATE_ORDER_BY_ADMIN_END: "UPDATE_ORDER_BY_ADMIN_END",

  GET_A_ORDER_BY_ADMIN_START: "GET_A_ORDER_BY_ADMIN_START",
  GET_A_ORDER_BY_ADMIN_SUCCESS: "GET_A_ORDER_BY_ADMIN_SUCCESS",
  GET_A_ORDER_BY_ADMIN_FAILED: "GET_A_ORDER_BY_ADMIN_FAILED",
  GET_A_ORDER_BY_ADMIN_END: "GET_A_ORDER_BY_ADMIN_END",

  // -----------PROCESS

  GET_ALL_PROCESS_ORDER_START: "GET_ALL_PROCESS_ORDER_START",
  GET_ALL_PROCESS_ORDER_SUCCESS: "GET_ALL_PROCESS_ORDER_SUCCESS",
  GET_ALL_PROCESS_ORDER_FAILED: "GET_ALL_PROCESS_ORDER_FAILED",
  GET_ALL_PROCESS_ORDER_END: "GET_ALL_PROCESS_ORDER_END",

  ADD_NEW_PROCESS_BY_ADMIN_START: "ADD_NEW_PROCESS_BY_ADMIN_START",
  ADD_NEW_PROCESS_BY_ADMIN_SUCCESS: "ADD_NEW_PROCESS_BY_ADMIN_SUCCESS",
  ADD_NEW_PROCESS_BY_ADMIN_FAILED: "ADD_NEW_PROCESS_BY_ADMIN_FAILED",
  ADD_NEW_PROCESS_BY_ADMIN_END: "ADD_NEW_PROCESS_BY_ADMIN_END",

  UPDATE_PROCESS_BY_ADMIN_START: "UPDATE_PROCESS_BY_ADMIN_START",
  UPDATE_PROCESS_BY_ADMIN_SUCCESS: "UPDATE_PROCESS_BY_ADMIN_SUCCESS",
  UPDATE_PROCESS_BY_ADMIN_FAILED: "UPDATE_PROCESS_BY_ADMIN_FAILED",
  UPDATE_PROCESS_BY_ADMIN_END: "UPDATE_PROCESS_BY_ADMIN_END",

  DELETE_A_PROCESS_START: "DELETE_A_PROCESS_START",
  DELETE_A_PROCESS_SUCCESS: "DELETE_A_PROCESS_SUCCESS",
  DELETE_A_PROCESS_END: "DELETE_A_PROCESS_END",
  DELETE_A_PROCESS_FAILED: "DELETE_A_PROCESS_FAILED",

  DELETE_A_ORDER_BY_ADMIN_START: "DELETE_A_ORDER_BY_ADMIN_START",
  DELETE_A_ORDER_BY_ADMIN_SUCCESS: "DELETE_A_ORDER_BY_ADMIN_SUCCESS",
  DELETE_A_ORDER_BY_ADMIN_END: "DELETE_A_ORDER_BY_ADMIN_END",
  DELETE_A_ORDER_BY_ADMIN_FAILED: "DELETE_A_ORDER_BY_ADMIN_FAILED",

  GET_A_ORDER_PROCESS_BY_ADMIN_START: "GET_A_ORDER_PROCESS_BY_ADMIN_START",
  GET_A_ORDER_PROCESS_BY_ADMIN_SUCCESS: "GET_A_ORDER_PROCESS_BY_ADMIN_SUCCESS",
  GET_A_ORDER_PROCESS_BY_ADMIN_FAILED: "GET_A_ORDER_PROCESS_BY_ADMIN_FAILED",
  GET_A_ORDER_PROCESS_BY_ADMIN_END: "GET_A_ORDER_PROCESS_BY_ADMIN_END",
};
